// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"emphasized-text-view_shadow___GI6q","emphasized":"emphasized-text-view_emphasized__2ixNZ"};